/* eslint-disable react/prop-types */
import { MapContainer } from 'react-leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import { latLngBounds } from 'leaflet';
import { useMemo } from 'react';
import { googleMapsApi } from '../../../components/api';

export const GoogleMap = ({ children, setMap, width, userCoords, userZoom = 16 }) => {

 
const defaultCenter = [23.512, 80.329]; // default coordinates [lat, lng]
 
const center = useMemo(() => {
  if (userCoords && userCoords.lat && userCoords.lng) {
    return { lat: userCoords.lat, lng: userCoords.lng };
  } 
    // fallback to default if no userCoords
    return { lat: defaultCenter[0], lng: defaultCenter[1] };
  
}, [])



  const bounds =  useMemo(() => latLngBounds(center), [center]);

  // A unique key helps remount the container if needed
  const mapKey = `${center.lat}-${center.lng}`;

  return (
      <MapContainer
        style={{ height: '100%', width: '100%' }}
        zoom={userZoom}
        center={center}
        bounds={bounds}
        whenReady={setMap}
      >
        <ReactLeafletGoogleLayer
          googleMapsLoaderConf={{
            apiKey: googleMapsApi,
            libraries: ['places']
          }}
          type="hybrid"
        />
        {children}
      </MapContainer>
  );
};
 